/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * TFA API
 * API for TFA
 * OpenAPI spec version: 2.0.0 (api.admin.v1)
 */

/**
 * * `change_amount` - change_amount
 */
export type AmendPaymentChangeAmountRequestActionEnum = typeof AmendPaymentChangeAmountRequestActionEnum[keyof typeof AmendPaymentChangeAmountRequestActionEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AmendPaymentChangeAmountRequestActionEnum = {
  change_amount: 'change_amount',
} as const;
